<template>
  <div class="wrapper d-flex justify-content-center align-items-center">
    <div class="flex-row w-100">
      <el-card class="not-permission text-center">
        <div class="row">
          <div class="col">
            <h1 data-cy="no-permission"><span class="not-found-icon nc-icon nc-notification-70"></span>Sin permisos</h1>
            <p>No tiene permisos para acceder a este recurso</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-button @click="goHome" type="primary" icon="el-icon-back" data-cy="comeback-button">
              Volver Atrás
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {Button, Card} from "element-ui";
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "NoPermission",
  components: {
    [Button.name]: Button,
    [Card.name]: Card,
  },
  mixins: [
    RouterMixin
  ],
}
</script>

<style lang="scss">
.not-permission {
  .not-found-icon {
    margin-right: 10px;
  }

  .centered {
    h1, i {
      font-size: 50px;
    }

    p {
      font-size: 20px;
    }

    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 160px);
  }
}
</style>
